export type RoleKey = 'gerant' | 'responsable_atelier' | 'vendeur';

export interface Permission {
  id: string;
  label: string;
  description: string;
  categorie: string;
}

export interface PermissionMatrix {
  [permId: string]: {
    [role in RoleKey]: boolean;
  };
}

export const permissionsList: Permission[] = [
  // Tableau de bord
  { id: 'dash_gerant', label: 'Dashboard Gérant', description: 'Accès aux KPIs, CA, statistiques globales', categorie: 'Tableaux de bord' },
  { id: 'dash_atelier', label: 'Kanban Atelier', description: 'Vue kanban de toutes les commandes en production', categorie: 'Tableaux de bord' },
  { id: 'dash_vendeur', label: 'Dashboard Vendeur', description: 'Accès au dashboard de ventes et commandes', categorie: 'Tableaux de bord' },
  { id: 'dash_coupeur', label: 'Dashboard Coupeur', description: 'Vue des commandes à couper (mobile)', categorie: 'Tableaux de bord' },
  { id: 'dash_tailleur', label: 'Dashboard Tailleur', description: 'Vue des commandes à coudre (mobile)', categorie: 'Tableaux de bord' },

  // Commandes
  { id: 'cmd_voir', label: 'Voir les commandes', description: 'Consulter la liste et le détail des commandes', categorie: 'Commandes & Production' },
  { id: 'cmd_creer', label: 'Créer une commande', description: 'Enregistrer une nouvelle commande de couture', categorie: 'Commandes & Production' },
  { id: 'cmd_modifier', label: 'Modifier une commande', description: 'Éditer les infos d\'une commande existante', categorie: 'Commandes & Production' },
  { id: 'cmd_valider', label: 'Valider étapes production', description: 'Avancer une commande dans le workflow', categorie: 'Commandes & Production' },
  { id: 'cmd_affecter', label: 'Affecter coupeur/tailleur', description: 'Assigner du personnel à une commande', categorie: 'Commandes & Production' },

  // Ventes
  { id: 'vente_voir', label: 'Voir les ventes', description: 'Consulter l\'historique des ventes de tissu', categorie: 'Ventes & Clients' },
  { id: 'vente_creer', label: 'Créer une vente', description: 'Enregistrer une vente de tissu au comptoir', categorie: 'Ventes & Clients' },
  { id: 'client_voir', label: 'Voir les clients', description: 'Accéder à la fiche et historique clients', categorie: 'Ventes & Clients' },

  // Stocks
  { id: 'stock_voir', label: 'Voir les stocks', description: 'Consulter les niveaux de stock et alertes', categorie: 'Stocks' },
  { id: 'stock_reappro', label: 'Réapprovisionner', description: 'Ajouter du stock à un produit existant', categorie: 'Stocks' },
  { id: 'stock_creer', label: 'Créer un produit', description: 'Ajouter un nouveau tissu au catalogue', categorie: 'Stocks' },
  { id: 'stock_modifier', label: 'Modifier un produit', description: 'Éditer les infos d\'un produit existant', categorie: 'Stocks' },
  { id: 'tissu_assigner', label: 'Assigner tissu commande', description: 'Lier un tissu du stock à une commande', categorie: 'Stocks' },

  // Finance
  { id: 'paie_voir', label: 'Voir la paie', description: 'Consulter les fiches de paie du personnel', categorie: 'Finance & Paie' },
  { id: 'paie_valider', label: 'Valider la paie', description: 'Marquer la paie comme versée', categorie: 'Finance & Paie' },
  { id: 'ca_voir', label: 'Voir le CA', description: 'Accéder aux chiffres d\'affaires et rapports', categorie: 'Finance & Paie' },

  // Administration
  { id: 'user_voir', label: 'Voir les utilisateurs', description: 'Consulter la liste des employés', categorie: 'Administration' },
  { id: 'user_gerer', label: 'Gérer les utilisateurs', description: 'Créer, modifier, désactiver des comptes', categorie: 'Administration' },
];

export const permissionsMatrix: PermissionMatrix = {
  dash_gerant:     { gerant: true,  responsable_atelier: false, vendeur: false, coupeur: false, tailleur: false },
  dash_atelier:    { gerant: true,  responsable_atelier: true,  vendeur: false, coupeur: false, tailleur: false },
  dash_vendeur:    { gerant: true,  responsable_atelier: false, vendeur: true,  coupeur: false, tailleur: false },
  dash_coupeur:    { gerant: false, responsable_atelier: true,  vendeur: false, coupeur: true,  tailleur: false },
  dash_tailleur:   { gerant: false, responsable_atelier: true,  vendeur: false, coupeur: false, tailleur: true  },

  cmd_voir:        { gerant: true,  responsable_atelier: true,  vendeur: true,  coupeur: true,  tailleur: true  },
  cmd_creer:       { gerant: true,  responsable_atelier: false, vendeur: true,  coupeur: false, tailleur: false },
  cmd_modifier:    { gerant: true,  responsable_atelier: true,  vendeur: true,  coupeur: false, tailleur: false },
  cmd_valider:     { gerant: true,  responsable_atelier: true,  vendeur: false, coupeur: true,  tailleur: true  },
  cmd_affecter:    { gerant: true,  responsable_atelier: true,  vendeur: false, coupeur: false, tailleur: false },

  vente_voir:      { gerant: true,  responsable_atelier: false, vendeur: true,  coupeur: false, tailleur: false },
  vente_creer:     { gerant: true,  responsable_atelier: false, vendeur: true,  coupeur: false, tailleur: false },
  client_voir:     { gerant: true,  responsable_atelier: false, vendeur: true,  coupeur: false, tailleur: false },

  stock_voir:      { gerant: true,  responsable_atelier: true,  vendeur: true,  coupeur: false, tailleur: false },
  stock_reappro:   { gerant: true,  responsable_atelier: false, vendeur: false, coupeur: false, tailleur: false },
  stock_creer:     { gerant: true,  responsable_atelier: false, vendeur: false, coupeur: false, tailleur: false },
  stock_modifier:  { gerant: true,  responsable_atelier: false, vendeur: false, coupeur: false, tailleur: false },
  tissu_assigner:  { gerant: true,  responsable_atelier: true,  vendeur: false, coupeur: false, tailleur: false },

  paie_voir:       { gerant: true,  responsable_atelier: false, vendeur: false, coupeur: false, tailleur: false },
  paie_valider:    { gerant: true,  responsable_atelier: false, vendeur: false, coupeur: false, tailleur: false },
  ca_voir:         { gerant: true,  responsable_atelier: false, vendeur: false, coupeur: false, tailleur: false },

  user_voir:       { gerant: true,  responsable_atelier: false, vendeur: false, coupeur: false, tailleur: false },
  user_gerer:      { gerant: true,  responsable_atelier: false, vendeur: false, coupeur: false, tailleur: false },
};

export const categories = [...new Set(permissionsList.map(p => p.categorie))];
